<div *ngIf="message?.type == 'confirm'" class="confirm-overlay">
    <div class="confirm-card" [class.confirm-danger]="isDanger" role="alertdialog" aria-modal="true"
        aria-labelledby="confirmTitle" aria-describedby="confirmText">
        <div class="confirm-icon">
            <i class="fas" [ngClass]="isDanger ? 'fa-trash-alt' : 'fa-question'"></i>
        </div>
        <h5 id="confirmTitle" class="confirm-title">{{ isDanger ? 'Please Confirm Deletion' : 'Please Confirm' }}</h5>
        <p id="confirmText" class="confirm-message" [innerHTML]="message.text"></p>
        <div class="confirm-actions">
            <button type="button" class="confirm-btn confirm-btn-no" (click)="message.noFn()">No</button>
            <button type="button" class="confirm-btn confirm-btn-yes" (click)="message.yesFn()">Yes</button>
        </div>
    </div>
</div>
